import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaymentMethod} from "../../../user/payment-method";
import {IDropdownListItem} from "../../../shared/components/dropdown-list/dropdown-list-item";
import {UserSubscription, UserSubscriptionType} from "../../../user/user-subscription";
import * as fromStore from "../../../store";
import {filter, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {TextUtils} from "../../../shared/utils/text-utils";


@Component({
    selector: 'db-payment-method-item',
    templateUrl: './payment-method-item.component.html',
    styleUrls: ['./payment-method-item.component.scss'],
    standalone: false
})
export class PaymentMethodItemComponent implements OnInit {

  @Input() paymentMethod: PaymentMethod;
  @Input() userPaymentMethod?: string;
  @Input() selectable: boolean;
  @Input() default: boolean = false;
  @Input() selected: boolean;
  @Input() withShadow: boolean = false;
  @Input() fromUpgrade: boolean = false;
  @Input() showDropdown: boolean = true;
  @Input() userSubscription?: UserSubscription;
  @Output() onSelect: EventEmitter<{paymentMethod: PaymentMethod}>;
  @Output() onSetDefault: EventEmitter<any>;
  @Output() onDelete: EventEmitter<{paymentMethod: PaymentMethod}>;
  @Input() fromCheckout?: boolean = false;
  public paymentMethodActions: IDropdownListItem[];
  public UserSubscriptionType: any = UserSubscriptionType;
  public isMobile: boolean = false;

  constructor(
    private _store: Store<fromStore.DbStoreState>,

  ) {
    this.onSelect = new EventEmitter<{paymentMethod: PaymentMethod}>();
    this.onSetDefault = new EventEmitter<any>();
    this.onDelete = new EventEmitter<{paymentMethod: PaymentMethod}>();
  }

  ngOnInit() {


    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription))
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
        this.userPaymentMethod = userSubscription && userSubscription.paymentType;
        if (this.userPaymentMethod === 'card') {
          if ( this.paymentMethod && !this.paymentMethod.active ) {
            this.paymentMethodActions = [
              {
                label: TextUtils.getText('text_makeMainPaymentMethod'),
                action: () => {
                  this.setDefault('main');
                }
              },
              {
                label: TextUtils.getText('text_removePaymentMethodTitle'),
                action: () => {
                  this.delete();
                }
              }
            ];
          }
          else {
            this.paymentMethodActions = [
              {
                label: TextUtils.getText('text_removePaymentMethodTitle'),
                action: () => {
                  this.delete();
                }
              }
            ];
          }
        }
        else {
          if (this.paymentMethod && this.paymentMethod.active && this.userSubscription && !(this.userSubscription.type === UserSubscriptionType.PREMIUM || this.userSubscription.type === UserSubscriptionType.ONE_PRODUCT || this.userSubscription.type === UserSubscriptionType.FREE)) {
            this.paymentMethodActions = [
              {
                label: TextUtils.getText('text_makeMainPaymentMethod'),
                action: () => {
                  this.setDefault('changeFromPayPal');
                }
              }
            ];
          }
          else {
            if (this.userSubscription && (this.userSubscription.type === UserSubscriptionType.PREMIUM || this.userSubscription.type === UserSubscriptionType.ONE_PRODUCT || this.userSubscription.type === UserSubscriptionType.FREE)) {
              this.paymentMethodActions = [
                {
                  label: TextUtils.getText('text_makeMainPaymentMethod'),
                  action: () => {
                    this.setDefault('changeFromPayPal');
                  }
                },
                {
                  label: TextUtils.getText('text_removePaymentMethodTitle'),
                  action: () => {
                    this.delete();
                  }
                }
              ];
            }
            else {
              this.paymentMethodActions = [
                {
                  label: TextUtils.getText('text_makeMainPaymentMethod'),
                  action: () => {
                    this.setDefault('changeFromPayPal');
                  }
                },
                {
                  label: 'Make default payment method for additional fees',
                  action: () => {
                    this.setDefault('extra');
                  }
                },
                {
                  label: TextUtils.getText('text_removePaymentMethodTitle'),
                  action: () => {
                    this.delete();
                  }
                }
              ];
            }
          }
        }
      });
    if (window.innerWidth < 665) {
      this.isMobile = true;
    }
  }

  public select(): void {
    this.onSelect.emit({paymentMethod: this.paymentMethod});
  }

  public setDefault(type): void {
    this.onSetDefault.emit({paymentMethod: this.paymentMethod, type: type});
  }

  public delete(): void {
    this.onDelete.emit({paymentMethod: this.paymentMethod});
  }

}
